import { Box, Typography } from "@mui/material";
import { getWorkflowLogs, getUsers } from "API/swesum";
import MainLayout1 from "Components/UI/Layout/MainLayout1";
import { WorkflowTable } from "./components/WorkflowTable";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

export function Workflows() {
  const [workflowLogs, setWorkflowLogs] = useState([]);
  const [users, setUsers] = useState([]);

  const asyncGetWorkflowLogs = async (from, to) => {
    const res = await getWorkflowLogs(from, to);

    if (res.status === 200) setWorkflowLogs(res.data);
  };

  const asyncGetUsers = async () => {
    const res = await getUsers();
    setUsers(res);
  };

  useEffect(() => {
    asyncGetWorkflowLogs(
      dayjs().startOf("month").format("YYYY-MM-DD"),
      dayjs().endOf("month").format("YYYY-MM-DD")
    );
    asyncGetUsers();
  }, []);

  return (
    <>
      <MainLayout1>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1.0rem",
          }}
        >
          <Typography variant="h5">Arbetsflöden</Typography>
        </Box>
        <WorkflowTable
          logs={workflowLogs}
          updateLogs={asyncGetWorkflowLogs}
          users={users}
        />
      </MainLayout1>
    </>
  );
}
